// ============================================================
//  quoteKlaviyoBridge.js — [F3-Lite v1.4 / F5 Verified]
//  Purpose: SinglePush quote → Klaviyo (SDK-v2-safe flattening)
//  Adds: per-item field flattening for new SDK, full UI clear,
//        consent + organization profile updates.
// ============================================================

(function () {
  if (window.__f3BridgeInitialized) return;
  window.__f3BridgeInitialized = true;

  const DEBUG_PREFIX = "[F3-Lite]";
  const safeLog = (...a) => console.log(DEBUG_PREFIX, ...a);

  // ---------- helpers ----------
  const normalizeHttps = (u) => (u?.startsWith("//") ? "https:" + u : u || "");
  const readQuoteCart = () => {
    try { return JSON.parse(localStorage.getItem("quoteCart")) || []; }
    catch { return []; }
  };

  const flattenItems = (raw = []) =>
    (raw || []).map((i) => ({
      title: String(i.title ?? ""),
      qty: Number(i.qty ?? 1),
      image: normalizeHttps(i.image ?? ""),
      productId: String(i.productId ?? i.product_id ?? ""),
      variantId: String(i.variantId ?? i.variant_id ?? ""),
    }));

  const clearFormAndCart = (form) => {
    try { localStorage.removeItem("quoteCart"); } catch {}
    try { form?.reset?.(); } catch {}
    window.dispatchEvent(new CustomEvent("quote:submitted")); // triggers UI clear
  };

  // ---------- build payload ----------
  function buildPayload(form) {
    const d = new FormData(form);
    const email = (d.get("email_confirm") || d.get("email") || "").trim().toLowerCase();

    const payload = {
      quote_id:
        "BEL-" +
        new Date().toISOString().slice(0, 10).replace(/-/g, "") +
        "-" +
        Math.random().toString(36).substring(2, 6).toUpperCase(),
      customer_first_name: d.get("first_name") || "",
      customer_last_name: d.get("last_name") || "",
      customer_email: email,
      customer_phone: d.get("phone") || "",
      customer_message: d.get("message") || d.get("note") || "",
      customer_company: d.get("company") || "",
      customer_city: d.get("city") || "",
      customer_consent: !!d.get("quote_consent"),
      marketing_consent: !!d.get("marketing_consent"),
      items: flattenItems(readQuoteCart()),
      submitted_at: new Date().toLocaleString("es-CL", {
        timeZone: "America/Santiago",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
      $is_session_activity: true,
      $use_ip: true,
    };

    if (payload.marketing_consent) payload.$consent = ["email"];
    return payload;
  }

  // ---------- send to Klaviyo ----------
  function sendToKlaviyo(payload, form) {
  const useLegacy = typeof _learnq !== "undefined";
  const useNewSDK = typeof window.klaviyo !== "undefined";

  // 1️⃣ Reset identity (same as before)
  try {
    if (useLegacy && _learnq.push) {
      _learnq.push(["reset"]);
      setTimeout(() => localStorage.removeItem("_kla_id"), 150);
    }
    if (useNewSDK && window.klaviyo?.push) window.klaviyo.push(["reset"]);
  } catch (e) {
    safeLog("⚠️ reset skipped:", e.message);
  }

  // 2️⃣ Identify profile
  setTimeout(() => {
    const id = {
      $email: payload.customer_email,
      $first_name: payload.customer_first_name,
      $last_name: payload.customer_last_name,
      $phone_number: payload.customer_phone,
      $city: payload.customer_city,
      $organization: payload.customer_company,
    };

    // Apply marketing consent directly on the profile
    if (payload.marketing_consent) {
      id.$consent = ["email"];
      id.$consent_method = "quote_form";
      id.$source = "Quote Form";
      id.$subscription_status = { email: "subscribed" }; // ✅ ensures profile shows “Subscribed”
    }

    safeLog("🔄 Identify →", id.$email);
    try {
      if (useLegacy) _learnq.push(["identify", id]);
      if (useNewSDK) window.klaviyo.push(["identify", id]);
    } catch (e) {
      console.warn(DEBUG_PREFIX, "Identify failed", e);
    }
  }, 300);

  // 3️⃣ Track event (restore items array, omit private $ fields)
  setTimeout(() => {
    const { $is_session_activity, $use_ip, $consent, ...clean } = payload;
    // Flatten items only one level deep, preserving the array
    clean.items = (payload.items || []).map(i => ({
      title: i.title,
      qty: i.qty,
      image: i.image,
      productId: i.productId,
      variantId: i.variantId,
    }));

    safeLog("✅ Quote Requested → Klaviyo (final payload)", clean);
    try {
      if (useLegacy) _learnq.push(["track", "Quote Requested", clean]);
      if (useNewSDK) window.klaviyo.push(["track", "Quote Requested", clean]);
    } catch (e) {
      console.warn(DEBUG_PREFIX, "⚠️ Track failed:", e);
    }

    clearFormAndCart(form);
  }, 900);
}


  // ---------- attach ----------
  const form = document.querySelector("#quote-request-form, .quote-cart-form");
  if (!form) return safeLog("⚠️ No quote form detected");
  if (form.dataset.f3Bound === "true") return safeLog("🔒 Already bound");
  form.dataset.f3Bound = "true";
  safeLog("🧩 Quote form listener attached");

  let lock = false;
  form.addEventListener("submit", (e) => {
  if (lock) { e.preventDefault(); return safeLog("🧱 Duplicate submit"); }
  lock = true; setTimeout(() => (lock = false), 1200);
  e.preventDefault();

  const btn = form.querySelector("[data-quote-submit]");
  if (btn) { btn.disabled = true; btn.textContent = "Enviando..."; }

  // 🧩 1️⃣ Take a live snapshot of the cart *before* anything clears
  let quoteCartSnapshot = [];
  try {
    quoteCartSnapshot = JSON.parse(localStorage.getItem("quoteCart")) || [];
    safeLog("📦 Captured cart snapshot:", quoteCartSnapshot);
  } catch (err) {
    safeLog("⚠️ Could not parse quoteCart before send", err);
  }

  // 🧩 2️⃣ Inject that snapshot into payload manually
  setTimeout(() => {
    try {
      const payload = buildPayload(form);
      payload.items = flattenItems(quoteCartSnapshot); // <-- use snapshot directly
      sendToKlaviyo(payload, form);
    } catch (err) {
      console.error(DEBUG_PREFIX, "❌ Bridge error", err);
    }
  }, 150);
});

})();
